module.exports = __webpack_public_path__ + "06d45478959e8c15675cbdad1083d093.svg";